import { render, staticRenderFns } from "./vinculo.vue?vue&type=template&id=41163811&"
import script from "./vinculo.vue?vue&type=script&lang=js&"
export * from "./vinculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports